import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { profilePush } from 'actions/index'
import { useBusinessCard } from 'components/BusinessCard/context'
import { Section, Row } from 'components/BusinessCard/components/StyledComponents'
import { H6, P, Link } from '@PipelineDeals/shared-react-components'

const Deals = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { cardMeta: { showOnlyFields }, callbacks: { onClose }, resource } = useBusinessCard()

  if (!showOnlyFields.includes('deals') || !resource.deals?.length) return null

  const handleDealClick = (event, dealId) => {
    dispatch(profilePush({ event, type: 'Deal', id: dealId }))
    if (onClose) onClose(false)
  }

  return (
    <Section>
      <H6>{t('businessCard.labels.deals')}</H6>
      {resource.deals.map(deal => (
        <Row key={deal.id}>
          <Link
            href={`/deals/${deal.id}`}
            onClick={e => handleDealClick(e, deal.id)}
            withTextDecoration={false}
          >
            <P>{deal.name}</P>
          </Link>
        </Row>
      ))}
    </Section>
  )
}

export default Deals
